export default __webpack_public_path__ + "static/media/werewolves-open-eyes.90b6fbf5.mp3";